export enum CompanyPhotoType {
  LOGO = 'logo',
  FAVICON = 'favicon',
  PROFILE = 'profile'
}
